import React, { useState, useEffect } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, Container } from "reactstrap";
import { FormSelect } from "../Controls";
import LaddaButton, { SLIDE_LEFT } from "react-ladda";
import style from "./styles.module.scss";

const initialFields = {
  agencyId: "",
  ratingId: "",
};

const ModalCreditRating = ({ open, toggle, assetId, agencies, onConfirm, getAgencies, services }) => {
  const [fields, setFields] = useState(initialFields);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [ratings, setRatings] = useState([]);

  useEffect(() => {
    getRatingsByAgencyId(fields.agencyId);
  }, [fields.agencyId]);

  const getRatingsByAgencyId = (agencyId) => {
    services.getRatingsByAgency &&
      services
        .getRatingsByAgency({
          agencyId,
        })
        .then(({ response }) => {
          if (response && response.result && response.result.Code == 200) {
            const { ratings } = response;
            setRatings(ratings);
          }
        });
  };

  const handleSave = async () => {
    const errors = validate(fields);
    setErrors(errors);

    if (Object.keys(errors).length == 0) {
      setLoading(true);
      const result = await onConfirm({ ...fields, assetId: assetId });
      setLoading(false);

      if (result == 200) {
        toggle();
        setFields(initialFields);
        getAgencies();
      }
    }
  };

  const onChange = (name, value) => {
    setFields({ ...fields, [name]: value });
    setErrors({ ...errors, [name]: undefined });
  };

  return (
    <Modal isOpen={open} toggle={toggle} className={style.modal}>
      <ModalHeader toggle={toggle}>Add Credit Rating</ModalHeader>
      <ModalBody>
        <Container className={style.container}>
          <Row>
            <Col lg="6">
              <FormSelect
                name="agencyId"
                label="Select Agency"
                selectItems={agencies}
                getSelectItemId={(i) => i.CreditRatingAgencyId}
                getSelectItemName={(i) => `${i.CreditRatingAgencyName}`}
                value={fields.agencyId}
                error={errors.agencyId}
                disabled={loading}
                onChange={onChange}
              />
            </Col>
            <Col lg="6">
              <FormSelect
                name="ratingId"
                label="Select Risk"
                selectItems={ratings}
                getSelectItemId={(i) => i.CreditRatingAgencyScore}
                getSelectItemName={(i) => `${i.CreditRatingAgencyScore}`}
                value={fields.ratingId}
                error={errors.ratingId}
                disabled={loading}
                onChange={onChange}
              />
            </Col>
          </Row>
        </Container>
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={toggle}>
          Cancel
        </Button>
        <LaddaButton
          className="btn btn-ladda btn-primary pl-3 pr-3"
          loading={loading}
          disabled={false}
          onClick={() => handleSave()}
          data-style={SLIDE_LEFT}
        >
          <i className="fa fa-floppy-o mr-1" aria-hidden="true"></i>
          Save
        </LaddaButton>
      </ModalFooter>
    </Modal>
  );
};

export function parseDate(date) {
  const dateRegex = /\b\w{3} \d{2} \d{4}\b/;
  const matchedDate = String(date).match(dateRegex);
  date = matchedDate ? matchedDate[0] : date;
  if (date instanceof Date) {
    return date.toISOString();
  }

  if (date.indexOf("T") > -1) {
    return date;
  }

  if (!date || date == "" || date == "0000-00-00") {
    return "";
  }
  try {
    return new Date(`${date}T00:00`).toISOString();
  } catch (e) {
    return date;
  }
}

function validate(fields) {
  const errors = {};

  Object.entries(fields).forEach(([name, value]) => {
    if (value === undefined || value === "" || !value) errors[name] = "Required field";
  });

  return errors;
}

export default ModalCreditRating;
